import React from 'react';

export class BottomPlaceholder extends React.Component {
  public render(): JSX.Element {
    return <div data-hook="bottom-placeholder" />;
  }
}
